module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_DASHBOARD_E_ANALYTICS.49841acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dashboardAnalytics/Mobile_Carrosel_DASHBOARD_E_ANALYTICS.png
// module id = 190
// module chunks = 0